<template>
  <div
    v-if="levelOfCare"
    class="eoc-loc badge text-white"
    :style="{ backgroundColor: levelOfCare.color }"
  >
    {{ levelOfCare.name }}
  </div>
</template>

<script>
export default {
  name: "EocLocBadge",
  props: ["levelOfCare"]
};
</script>
